import { h, render } from "preact";
import "./index.module.scss";
import App from "./components/app";

// if a URL contains a hashbang (/#/) re-route to non-hashed version
// this can only be done on client-side as the hash is never sent to the server
if (location.hash) {
    location.href = `${location.protocol}//${location.host}/products${location.hash.substring(1)}`
}

render(<App />, document.getElementById('products-client'));
